export const aiContentIndex = {
  "universities": [
    {
      "name": "University of Hull",
      "content_domains": [
        {
          "domain": "Website Content",
          "influence_score": 75,
          "citation_count": 1200,
          "social_media_presence": 70,
          "research_impact": 65,
          "industry_collaborations": 60,
          "content_quality": 80,
          "seo_optimization": 78,
          "user_engagement": 72,
          "brand_visibility": 75,
          "thought_leadership": 70
        },
        {
          "domain": "Social Media",
          "influence_score": 68,
          "citation_count": 1100,
          "social_media_presence": 75,
          "research_impact": 60,
          "industry_collaborations": 62,
          "content_quality": 70,
          "seo_optimization": 65,
          "user_engagement": 74,
          "brand_visibility": 72,
          "thought_leadership": 68
        },
        {
          "domain": "Digital Media",
          "influence_score": 72,
          "citation_count": 1150,
          "social_media_presence": 73,
          "research_impact": 68,
          "industry_collaborations": 70,
          "content_quality": 74,
          "seo_optimization": 70,
          "user_engagement": 76,
          "brand_visibility": 74,
          "thought_leadership": 72
        },
        {
          "domain": "YouTube Content",
          "influence_score": 65,
          "citation_count": 1050,
          "social_media_presence": 68,
          "research_impact": 60,
          "industry_collaborations": 65,
          "content_quality": 68,
          "seo_optimization": 60,
          "user_engagement": 70,
          "brand_visibility": 68,
          "thought_leadership": 66
        },
        {
          "domain": "Thought Leadership",
          "influence_score": 70,
          "citation_count": 1250,
          "social_media_presence": 67,
          "research_impact": 72,
          "industry_collaborations": 75,
          "content_quality": 78,
          "seo_optimization": 75,
          "user_engagement": 71,
          "brand_visibility": 73,
          "thought_leadership": 80
        }
      ],
      "overall_content_score": 72,
      "content_strengths": [
        "SEO Optimization",
        "Content Quality",
        "Thought Leadership"
      ],
      "content_weaknesses": [
        "YouTube Content",
        "Industry Collaborations"
      ],
      "content_opportunities": [
        "Enhance YouTube strategy",
        "Expand industry partnerships"
      ],
      "key_insights": [
        "Strong website content quality",
        "Moderate social media engagement",
        "Potential for growth in digital media"
      ]
    },
    {
      "name": "Warwick Business School",
      "content_domains": [
        {
          "domain": "Website Content",
          "influence_score": 85,
          "citation_count": 1500,
          "social_media_presence": 80,
          "research_impact": 90,
          "industry_collaborations": 85,
          "content_quality": 88,
          "seo_optimization": 90,
          "user_engagement": 85,
          "brand_visibility": 88,
          "thought_leadership": 92
        },
        {
          "domain": "Social Media",
          "influence_score": 80,
          "citation_count": 1400,
          "social_media_presence": 88,
          "research_impact": 85,
          "industry_collaborations": 80,
          "content_quality": 82,
          "seo_optimization": 84,
          "user_engagement": 86,
          "brand_visibility": 85,
          "thought_leadership": 88
        },
        {
          "domain": "Digital Media",
          "influence_score": 82,
          "citation_count": 1450,
          "social_media_presence": 84,
          "research_impact": 88,
          "industry_collaborations": 82,
          "content_quality": 86,
          "seo_optimization": 87,
          "user_engagement": 84,
          "brand_visibility": 86,
          "thought_leadership": 90
        },
        {
          "domain": "YouTube Content",
          "influence_score": 78,
          "citation_count": 1350,
          "social_media_presence": 82,
          "research_impact": 80,
          "industry_collaborations": 78,
          "content_quality": 80,
          "seo_optimization": 82,
          "user_engagement": 83,
          "brand_visibility": 80,
          "thought_leadership": 85
        },
        {
          "domain": "Thought Leadership",
          "influence_score": 90,
          "citation_count": 1550,
          "social_media_presence": 86,
          "research_impact": 92,
          "industry_collaborations": 88,
          "content_quality": 94,
          "seo_optimization": 95,
          "user_engagement": 90,
          "brand_visibility": 92,
          "thought_leadership": 95
        }
      ],
      "overall_content_score": 85,
      "content_strengths": [
        "Thought Leadership",
        "Website Content",
        "Research Impact"
      ],
      "content_weaknesses": [
        "YouTube Content",
        "Industry Collaborations"
      ],
      "content_opportunities": [
        "Increase YouTube presence",
        "Leverage industry connections"
      ],
      "key_insights": [
        "Exceptional thought leadership",
        "High research impact",
        "Strong SEO performance"
      ]
    }
  ],
  "chart_data": {
    "title": "AI Content Index Analysis",
    "data": [
      {
        "name": "University of Hull",
        "series": [
          {
            "name": "Website Content",
            "value": 75
          },
          {
            "name": "Social Media",
            "value": 68
          },
          {
            "name": "Digital Media",
            "value": 72
          },
          {
            "name": "YouTube Content",
            "value": 65
          },
          {
            "name": "Thought Leadership",
            "value": 70
          }
        ]
      },
      {
        "name": "Warwick Business School",
        "series": [
          {
            "name": "Website Content",
            "value": 85
          },
          {
            "name": "Social Media",
            "value": 80
          },
          {
            "name": "Digital Media",
            "value": 82
          },
          {
            "name": "YouTube Content",
            "value": 78
          },
          {
            "name": "Thought Leadership",
            "value": 90
          }
        ]
      }
    ]
  },
  "content_summary": {
    "overall_leader": {
      "university": "Warwick Business School",
      "average_score": 85.0,
      "strongest_domains": [
        "Thought Leadership",
        "Website Content",
        "Research Impact"
      ]
    },
    "domain_leaders": {
      "Website Content": "Warwick Business School",
      "Social Media": "Warwick Business School",
      "Digital Media": "Warwick Business School",
      "YouTube Content": "Warwick Business School",
      "Thought Leadership": "Warwick Business School"
    },
    "content_distribution": {
      "excellent": 1,
      "good": 1,
      "average": 0,
      "below_average": 0
    }
  },
  "recommendations": [
    {
      "category": "content_improvement",
      "issue": "Limited YouTube content engagement",
      "recommendation": "Develop a targeted YouTube content strategy focusing on engaging educational videos and promotional materials.",
      "priority": "High",
      "priority_score": 3,
      "expected_impact": "Increase in user engagement and brand visibility",
      "target_score": 85,
      "university": "University of Hull"
    },
    {
      "category": "content_improvement",
      "issue": "Underutilized industry collaborations",
      "recommendation": "Strengthen existing partnerships and seek new collaborations to enhance research impact and content distribution.",
      "priority": "Medium",
      "priority_score": 2,
      "expected_impact": "Improved research impact and broader content reach",
      "target_score": 80,
      "university": "General"
    }
  ],
  "context": {
    "title": "AI Content Index Analysis",
    "summary": "This analysis evaluates the digital content strategies and online presence of UK-based universities, focusing on their website, social media, digital media, YouTube, and thought leadership.",
    "methodology": "The analysis was conducted using a combination of digital footprint assessment, social media analytics, website SEO evaluation, and research citation tracking.",
    "insights": [
      "Universities with strong SEO practices tend to have higher content visibility.",
      "Social media engagement is crucial for maintaining a dynamic digital presence.",
      "Thought leadership and academic influence significantly enhance overall content strategy effectiveness."
    ],
    "citations": []
  },
  "tab_name": "ai-content-index",
  "data": [
    {
      "name": "University of Hull",
      "series": [
        {
          "name": "Website Content",
          "value": 75
        },
        {
          "name": "Social Media",
          "value": 68
        },
        {
          "name": "Digital Media",
          "value": 72
        },
        {
          "name": "YouTube Content",
          "value": 65
        },
        {
          "name": "Thought Leadership",
          "value": 70
        }
      ]
    },
    {
      "name": "Warwick Business School",
      "series": [
        {
          "name": "Website Content",
          "value": 85
        },
        {
          "name": "Social Media",
          "value": 80
        },
        {
          "name": "Digital Media",
          "value": 82
        },
        {
          "name": "YouTube Content",
          "value": 78
        },
        {
          "name": "Thought Leadership",
          "value": 90
        }
      ]
    }
  ],
  "evidence_sources": [
    {
      "source": "University of Hull",
      "url": "https://www.hull.ac.uk/study/postgraduate/mba",
      "title": "University Website Content Analysis - Digital Presence",
      "snippet": "Official University of Hull MBA program website with comprehensive course information, admission requirements, and digital content strategy.",
      "confidence": 0.9,
      "category": "digital_presence",
      "content_domain": "Website Content"
    },
    {
      "source": "Warwick Business School",
      "url": "https://www.wbs.ac.uk/courses/mba/",
      "title": "Warwick Business School MBA - Official Website",
      "snippet": "Official Warwick Business School MBA program website featuring program details, digital content, and comprehensive course information.",
      "confidence": 0.9,
      "category": "digital_presence",
      "content_domain": "Website Content"
    },
    {
      "source": "LinkedIn",
      "url": "https://www.linkedin.com/school/university-of-hull/",
      "title": "University of Hull LinkedIn - Social Media Presence",
      "snippet": "University of Hull's official LinkedIn page showcasing social media presence, engagement, and digital content strategy for MBA programs.",
      "confidence": 0.85,
      "category": "social_media",
      "content_domain": "Social Media"
    },
    {
      "source": "LinkedIn",
      "url": "https://www.linkedin.com/school/warwick-business-school/",
      "title": "Warwick Business School LinkedIn - Professional Network",
      "snippet": "Warwick Business School's LinkedIn presence demonstrating social media engagement, professional networking, and content strategy.",
      "confidence": 0.85,
      "category": "social_media",
      "content_domain": "Social Media"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=%22University%20of%20Hull%22%20digital%20media%20strategy%20",
      "title": "Search Results for: \"University of Hull\" digital media strategy ",
      "snippet": "Search results for \"University of Hull\" digital media strategy  from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.8,
      "category": "digital_strategy",
      "content_domain": "Digital Media"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=%22University%20of%20Hull%22%20online%20presence%20",
      "title": "Search Results for: \"University of Hull\" online presence ",
      "snippet": "Search results for \"University of Hull\" online presence  from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.8,
      "category": "digital_strategy",
      "content_domain": "Digital Media"
    },
    {
      "source": "YouTube",
      "url": "https://www.youtube.com/@UniversityofHull",
      "title": "University of Hull YouTube Channel - Video Content",
      "snippet": "University of Hull's official YouTube channel featuring video content, course information, and digital media strategy for MBA programs.",
      "confidence": 0.85,
      "category": "video_content",
      "content_domain": "Youtube Content"
    },
    {
      "source": "YouTube",
      "url": "https://www.youtube.com/@WarwickBusinessSchool",
      "title": "Warwick Business School YouTube - Educational Content",
      "snippet": "Warwick Business School's YouTube channel showcasing educational video content, program information, and digital media presence.",
      "confidence": 0.85,
      "category": "video_content",
      "content_domain": "Youtube Content"
    },
    {
      "source": "University of Hull Research",
      "url": "https://www.hull.ac.uk/research",
      "title": "University of Hull Research Publications - Academic Influence",
      "snippet": "University of Hull's research portal showcasing academic publications, thought leadership, and research impact in business education.",
      "confidence": 0.9,
      "category": "academic_influence",
      "content_domain": "Thought Leadership"
    },
    {
      "source": "Warwick Business School Research",
      "url": "https://www.wbs.ac.uk/research/",
      "title": "Warwick Business School Research - Academic Excellence",
      "snippet": "Warwick Business School's research center demonstrating academic influence, thought leadership, and research publications in business education.",
      "confidence": 0.8,
      "category": "academic_influence",
      "content_domain": "Thought Leadership"
    },
    {
      "source": "University of Hull Business",
      "url": "https://www.hull.ac.uk/business",
      "title": "University of Hull Industry Partnerships - Corporate Collaborations",
      "snippet": "University of Hull's business partnerships and industry collaborations showcasing corporate relationships and industry engagement.",
      "confidence": 0.9,
      "category": "partnerships",
      "content_domain": "Industry Collaborations"
    },
    {
      "source": "Warwick Business School Partnerships",
      "url": "https://www.wbs.ac.uk/partnerships/",
      "title": "Warwick Business School Corporate Partnerships",
      "snippet": "Warwick Business School's corporate partnerships and industry collaborations demonstrating business relationships and industry engagement.",
      "confidence": 0.8,
      "category": "partnerships",
      "content_domain": "Industry Collaborations"
    }
  ],
  "cached": false,
  "timestamp": "2025-08-28T23:31:42.265942",
  "models_used": [
    "gpt-4o-mini"
  ],
  "plan_type": "university_paid",
  "metadata": {
    "analysis_type": "ai_content_index",
    "country": "UK",
    "total_universities": 2,
    "course": "",
    "response_time": 37.29,
    "model_meta": {
      "model_used": "gpt-4o-mini",
      "analysis_engine": "ai_content_index_v1",
      "web_search_used": true
    }
  }
};
